<template>
  <div :id="record._id">
    <div v-bind:class="active ? '': ''">
      <div class="record-head">
        <div class="record-left">
          <v-icon :style="active ? 'opacity:0': ''" color="#E62163" @click="routeToDiary" class="mr-2 hover" size="12">fiber_manual_record</v-icon>
          <span class="hover pointer" @click="routeToDiary" v-if="record.subtype == 'Idea comment'">
            <v-icon color="blue" class="hover" size="18">chat</v-icon>
            <b class="text-blue ml-1">{{record.subtype}}</b>
            <span v-if="record.owner.username != record.user.username" class="text-blue">
              <v-icon color="#808F9C" class="hover" size="14">keyboard_arrow_right</v-icon>
              {{record.owner.username}}'s diary
            </span>
          </span>
          <span
            class="hover pointer"
            @click="routeToTrade"
            v-if="record.subtype == 'Trade comment'"
          >
            <v-icon color="#4dbac0" class="hover" size="18">show_chart</v-icon>
            <b class="text-green ml-1">{{record.subtype}}</b>
            <span
              v-if="record.owner.username && record.owner.username != record.user.username"
              class="text-green"
            >
              <v-icon color="#808F9C" class="hover" size="14">keyboard_arrow_right</v-icon>
              <span @click="emitUser(record.owner.username)">{{record.owner.username}}'s trade </span>
            </span>
          </span>
          <span v-if="record.subtype=='Chat'">
            <v-icon color="blue" size="18">chat</v-icon>
            <b class="text-blue ml-1">{{record.subtype}}</b>
          </span>
          <span class="text-grey">
            |
            <span @click="emitUser(record.user.username)" class="user-name">{{record.user.username}}</span>
            |
            {{openTime}}
          </span>
          <div class="record-body">
            <TextSlicer :text="record.data.message" :maxLength="200" />
          </div>
        </div>
      </div>
      <div class="record-right">
        <span @click="routeUser()" class="pointer hover">
          <Avatar
            v-if="record.user.avatar != null"
            class="timeline-avatar"
            :src="`https://tradeinpool.com/upload/${record.user.avatar}.png`"
            :size="40"
          ></Avatar>
          <Avatar v-else class="timeline-avatar" :username="record.user.username" :size="40"></Avatar>
        </span>
        <div class="record-menu">
          <MenuCard :record="record" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import VuePictureSwipe from "vue-picture-swipe";
import Avatar from "vue-avatar";
import MenuCard from "@/components/menuCard";
import TextSlicer from "@/components/textSlicer.vue";
var moment = require("moment-timezone");
export default {
  components: {
    Avatar,
    MenuCard,
    TextSlicer
    //VuePictureSwipe
  },
  props: ["record","id","active"],
  data() {
    return {
      focused: false,
      textRevision: "",
      setOpacity: "open",
      type: "",
      symbol: "",
      mainClass: "",
      fromNow: moment
        .tz(this.record.created, this.$store.getters.timezone)
        .fromNow(),
      remain: null //=> '26 years, 9 months, and 4 days'
    };
  },
  methods: {
    emitUser(user){
      this.$emit("emitUser",user)
    },
    routeToDiary() {
      this.$emit("read",this.id)
      return this.$router.push({
        path:
          "/journal/" +
          this.record.owner.username +
          "/" +
          this.record.urlDate +
          "/" +
          this.record.id
      });
    },
    routeToTrade() {
      this.$emit("read",this.id)
      return this.$router.push({
        path:
          "/trades/" +
          this.record.owner.username +
          "/" +
          this.record.urlDate +
          "/" +
          this.record._id
      });
    },
    routeUser() {
      return this.$router.push({ path: "/user/" + this.record.user.username });
    },
    scrollToId() {
      if (this.$route.params.message)
        setTimeout(() => {
          var element = document.getElementById(this.$route.params.message);
          var headerOffset = 90;
          var elementPosition = element.getBoundingClientRect().top;
          var offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });

          //document
          //  .getElementById(this.$route.params.message)
          //  .scrollIntoView({ block: "start", behavior: "smooth" });
        }, 500);
    }
  },
  filters: {},
  mounted() {
    
    if (this.$route.params.message == this.record._id) {
      this.scrollToId();
      this.focused = true;
    }

    //if (this.$route.params.message == this.record._id) {
    //  setTimeout(() => {
    //    this.$vuetify.goTo(this.$route.params.message, { offset: 0 });
    //  }, 3000);
    //}
    // updating record time
    /*
    this.updateTimes();
    setInterval(() => {
      this.updateTimes();
    }, 1000);
    */
  },

  computed: {
    openTime() {
      var value = this.record.created;
      var a = moment.tz(value, this.$store.getters.timezone).startOf('day');
      var b = moment.tz(new Date(), this.$store.getters.timezone).startOf('day');
      var diff = a.diff(b, "days"); // =1
      if (diff == 0)
        return  "Today | " + moment
          .tz(value, this.$store.getters.timezone)
          .format("HH:mm");
      else if (diff == -1)
        return  "Yesterday | " + moment
          .tz(value, this.$store.getters.timezone)
          .format("HH:mm");
      else
        return moment
          .tz(value, this.$store.getters.timezone)
          .format("YYYY-MM-DD | HH:mm");
    }
  }
};
</script>

<style scoped>
.sajz {
  font-size: 18px;
  margin-bottom: 3px;
  margin-right: 2px;
}

.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}

.close {
  opacity: 0.4;
}

.hourglass_empty {
  color: #4dbac0;
}

.record-body {
  color: white;
  width: auto;
  margin-left: 22px;
}
</style>
